import type { Household } from '../domain/household';

// DE: Startwerte aus dem Gespräch mit den Nutzern; alles ist später in den Einstellungen änderbar.
// EN: Starting values from the conversation with the users; everything can be changed in settings.
export const DEFAULT_HOUSEHOLD: Household = {
  members: [
    {
      id: 'a',
      name: 'Я',
      diet: 'pescatarian',
      excludedTags: [],
      dislikedProductIds: [],
      portionFactor: 1,
      meatAddOnsPerWeek: 0,
    },
    {
      id: 'b',
      name: 'Партнер',
      diet: 'omnivore',
      excludedTags: [],
      // DE: Mag keinen Oktopus und keine Trüffel; beides ist nicht im Katalog.
      // EN: Dislikes octopus and truffles; neither is in the catalog.
      dislikedProductIds: [],
      portionFactor: 1,
      meatAddOnsPerWeek: 2,
    },
  ],
  monthlyBudget: 660,
  wine: { bottlesPerWeek: 2, maxBottlePrice: 6 },
  storeIds: ['aldi', 'kaufland'],
  shoppingWeekdays: [1, 4, 6],
  workdays: [1, 2, 3, 4, 5],
  quick: { activeMinutes: 15, totalMinutes: 30 },
  lowEnergyDates: [],
  closedDates: [],
  backupKitDinners: 2,
  fishDinnersPerWeek: 3,
  breakfasts: {
    workday: ['eggs_toast', 'eggs_lavash'],
    weekend: ['syrnyky', 'oat_pancakes', 'shakshuka', 'eggs_toast'],
  },
};
